import { CountUp } from 'countup.js';

if (document.querySelector('.counter')) {
    const counters = document.querySelectorAll('[data-value]');

    counters.forEach(counter => {
        const startValue = parseFloat(counter.getAttribute('data-value'));
        const countUp = new CountUp(counter, startValue, {
            enableScrollSpy: true,
        });

        countUp.start();
    });
}